/* eslint-disable object-shorthand */
import { observable, action } from 'mobx';
import RFBluetoothInstance from '../../native-interact/RFBluetooth';
import { getFDISKForProd, waitRebootCpu1, setWorkState, getWorkState, getVersion } from '../../service/command';
import { event } from '../../native-interact/EventEmmiter';
import { WORK_MODE } from './work-mode';
import { upgradeStore } from './upgrade';


export const process = [
  {
    name: '进入调试模式',
    abort: '0',
    overtime: 60,
    execute: function () {
      return setWorkState(WORK_MODE.install.mode);
    }
  },
  {
    name: '检查模式',
    abort: '1',
    overtime: 60,
    execute: function () {
      return getWorkState().then((data) => {
        if (data.indexOf('app.mode=0') !== -1 || data.indexOf('app.mode=1') !== -1) {
          return Promise.resolve();
        }
        return Promise.reject(new Error(`模式切换失败，当前模式无法恢复：${data}`));
      }).catch((error) => {
        return Promise.reject(error);
      });
    }
  },
  {
    name: '分区重置',
    abort: '1',
    overtime: 60,
    execute: function () {
      return RFBluetoothInstance.sendCommand('fatfs mkfs', this);
    }
  },
  {
    name: '清空文件存储缓存',
    abort: '1',
    overtime: 60,
    execute: function () {
      return new Promise((resolve, reject) => {
        getVersion('cpu1').then((res) => {
          const version = res.version.split(' ')[0];
          upgradeStore.version = version;
          if (version >= 6.96) {
            RFBluetoothInstance.sendCommand('factoryreset', this);
          }
          resolve();
        });
      });
    }
  },
  {
    name: '发送重启cpu1命令',
    abort: '1',
    overtime: 60,
    execute: function () {
      if (upgradeStore.version < 6.96) {
        return RFBluetoothInstance.sendCommand('reboot cpu1', this);
      }
      return Promise.resolve();
    }
  },
  {
    name: '等待重启cpu1',
    abort: '1',
    execute: function () {
      return waitRebootCpu1();
    }
  },
  {
    name: '检查分区',
    abort: '1',
    execute: function () {
      return getFDISKForProd().then(() => {
        return Promise.reject(new Error('分区恢复失败'));
      }).catch((error) => {
        if (error.toString().indexOf('分区正确，不需要修复') !== -1) {
          return Promise.resolve();
        }
        return Promise.reject(error);
      });
    }
  },
  {
    name: '进入仓储模式',
    abort: '1',
    execute: function () {
      return setWorkState(WORK_MODE.frozen.mode);
    }
  },
  {
    name: '检查模式',
    abort: '1',
    execute: function () {
      return getWorkState().then((data) => {
        if (data.indexOf('app.mode=5') !== -1) {
          return Promise.resolve();
        }
        return Promise.reject(new Error(`模式切换失败：${data}`));
      }).catch((error) => {
        return Promise.reject(error);
      });
    }
  },
];

const processTasks = process.map((item) => {
  return Object.assign({}, item, {
    status: 'default',
    text: `${item.name}中...`,
    success: `${item.name}完成`,
    error: `${item.name}失败`,
    execute: item.execute.bind(item)
  });
});

export default class RecoverProcess {
  @observable tasks = processTasks;

  @observable done = [];

  @action addTasks(task) {
    this.done.push(task);
  }

  @action stopTask() {
    RFBluetoothInstance.endStep();
    event.endStep();
  }
}

export const recoverStore = new RecoverProcess();
